import { render, staticRenderFns } from "./PinDot.vue?vue&type=template&id=08f35b54"
import script from "./PinDot.vue?vue&type=script&lang=js"
export * from "./PinDot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports